import React, { Component } from "react";
import _ from 'lodash';
import Picky from 'react-picky';
import {Button, Row, Col, Modal} from 'react-bootstrap'
export default class ReAssign  extends Component {
  constructor(props){
    super(props)
   this.state= {
    selectedTemplate:_.find(props.templates, {"templateTitle":props.data.templateName})
   }
 }
 handleSelectTemplate = (e) => {
  this.setState({selectedTemplate: e});
}
reAssign = () => {
  const {data} = this.props;
  this.props.closeModal()
  const{selectedTemplate} = this.state
  let regions= data.region;
  let obj= {
    'region': [regions],
    'center': data.center,
    'client': data.client,
    'process': data.process,
    'templateId': selectedTemplate.id,
    'templateTitle': selectedTemplate.templateTitle
  }
  this.props.action.SamplingTemplateReAssign(obj)
 //this.props.action.mapSamplingTemplate(obj)   
  this.setState({selectedTemplate:[]})
}
  render(){
    const{data} = this.props;
    return(
      <Modal
      show={true}
      onHide={this.props.closeModal}
      dialogClassName="modal-90w"
      size="lg"
     //aria-labelledby="contained-modal-title-vcenter"
      centered
      >
      <Modal.Header closeButton>
      <Modal.Title id="example-custom-modal-styling-title">
        Replace Sampling Criteria     
      </Modal.Title>
      </Modal.Header>
      <Modal.Body>
   <div className='margingap'>
   <Row>
     <Col><Row>
     <Col md={3}>Region</Col>
     <Col md={1}>:</Col>
     <Col>{data.region.regionName}</Col></Row></Col>
     <Col><Row>
     <Col md={3}>Center</Col>
     <Col md={1}>:</Col>
     <Col>{_.map(data.center, (item) => {return item.centerName}).join(',') }</Col></Row></Col>
  </Row>
  <Row>
     <Col><Row>
     <Col md={3}>Client</Col>
     <Col md={1}>:</Col>
     <Col>{_.map(data.client, (item) => {return item.clientName}).join(',') }</Col></Row></Col>
     <Col><Row>
     <Col md={3}>Process</Col>
     <Col md={1}>:</Col>
     <Col>{_.map(data.process, (item) => {return item.processName}).join(',') }</Col></Row></Col>
   </Row>
    <Row>
   <Col>
   Sampling Criteria
   </Col>
   <Col>
  <Picky keepOpen={false}
     value={this.state.selectedTemplate}
     options={this.props.templates}
     onChange={this.handleSelectTemplate}
     open={false}
     valueKey="templateTitle"
     labelKey="templateTitle"
     multiple={false}
     includeSelectAll={false}
     includeFilter={true}
     clearFilterOnClose={true}
     placeholder='Select Sampling Criteria'
     dropdownHeight={600}
   /> 
    </Col>
    </Row>

    
     <br/>
     <Button className='buttonwidth' onClick={this.reAssign} block>Replace Sampling Criteria</Button>
     
</div>
     
     </Modal.Body>
      </Modal>

    )
  }
}